<template>
    <label class="inline-block cursor-pointer pl-2 text-xs font-semibold uppercase">
        <slot />
    </label>
</template>
